export class Observer<T> {
    subscribers: Array<(data: T) => void>
    constructor() {
        this.subscribers = []
    }

    subscribe(func: (data: T) => any) {
        this.subscribers.push(func)
    }
    unsubscribe(func: (data: T) => any) {
        this.subscribers = this.subscribers.filter((row) => row !== func)
    }

    fire(data: T) {
        this.subscribers.forEach((func) => func(data))
    }
}
